import { render, staticRenderFns } from "./LocationsResultItem.vue?vue&type=template&id=0421ace4&scoped=true&"
import script from "./LocationsResultItem.vue?vue&type=script&lang=js&"
export * from "./LocationsResultItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0421ace4",
  null
  
)

export default component.exports